import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const AzureLogo: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            width="32"
            height="35"
            viewBox="0 0 32 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.1403 24.5388C16.9484 24.2166 18.7563 23.8934 20.564 23.5689L20.615 23.558L17.8251 20.2051C16.2908 18.361 15.0354 16.8451 15.0354 16.8365C15.0354 16.8199 17.9161 8.80464 17.9323 8.77607C17.9377 8.76662 19.8981 12.1863 22.6844 17.0659C25.293 21.6341 27.4437 25.4006 27.4637 25.4359L27.5 25.5L18.6339 25.4988L9.7677 25.4976L15.1403 24.5388ZM4.5 23.5163C4.5 23.5116 5.81453 21.206 7.4212 18.3927L10.3424 13.2776L13.7467 10.3911C15.619 8.80346 17.156 7.50243 17.1622 7.50006C17.1683 7.4977 17.1437 7.56028 17.1074 7.63915C17.0712 7.71814 15.4077 11.3231 13.4108 15.6503L9.78009 23.518L7.14004 23.5215C5.68809 23.5234 4.5 23.521 4.5 23.5163Z"
                fill="currentColor"
            />
        </svg>
    );
};
